module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@3x-63dc589226f5fe33e339113d9f9c9fcf.png";